export default {"src":"/_next/static/media/logo-nexa.81189fac.svg","height":32,"width":130};